/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Match_Female15Inputs */

const en__field_enum_tuda_match_female15 = /** @type {(inputs: _Field_Enum_Tuda_Match_Female15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woman`)
};

const de__field_enum_tuda_match_female15 = /** @type {(inputs: _Field_Enum_Tuda_Match_Female15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frau`)
};

/**
* | output |
* | --- |
* | "Woman" |
*
* @param {_Field_Enum_Tuda_Match_Female15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_match_female15 = /** @type {((inputs?: _Field_Enum_Tuda_Match_Female15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Match_Female15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_match_female15(inputs)
	return de__field_enum_tuda_match_female15(inputs)
});
export { _field_enum_tuda_match_female15 as "_field_enum_TUDA_MATCH_FEMALE" }